const { permissions } = require('../../../../constants/permissions');

require('./servicePrincipal.style.scss');

const SEARCH_KEY = 'name';
const SERVER_API = 'api/v1/';

const MAIN_STATE = 'main';
const CREATE_STATE = 'create';

const HELP_MAIN = 'service-principals',
    HELP_CREATE = 'service-principal-add',
    HELP_EDIT = 'service-principal-edit'

class ServicePrincipalController {
    constructor($element, $scope, $filter, $window, $timeout, $q, crudService, storageService, dialogService, loginService, notificationService, contentSwitcherService, config, validationsService, iamPersistenceService) {
        this.$element = $element;
        this.$filter = $filter;
        this.$scope = $scope;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$q = $q;
        this.crudService = crudService;
        this.storageService = storageService;
        this.dialogService = dialogService;
        this.loginService = loginService;
        this.notificationService = notificationService;
        this.contentSwitcherService = contentSwitcherService;
        this.validationsService = validationsService;
        this.iamPersistenceService = iamPersistenceService;
        this.proxyUrl = config.proxyUrl;

        this.modalTitle = this.$filter('translate')('main.nav.top.admin.servicePrincipal.label');
        this.configTable();
        this.animateSwitcher = typeof this.$element[0].getBoundingClientRect === 'function';
        this.namePattern = this.validationsService.getTagNamePattern();
        this.uuidPattern = this.validationsService.getUuidPattern();
    }

    $onInit() {
        this.appId = '';
        this.tenantId = '';
        this.name = '';
        this.resource = '';
        this.appSecret = '';
        this.resetVariables();
        if (angular.isUndefined(this.storageService.getToken())) return;
        if (this.animateSwitcher) {
            this.minInnerHeight = this.getMinHeight();
        }
        this.actionButton = [
            {
                title: this.$filter('translate')('main.nav.top.admin.servicePrincipal.button.back'),
                action: () => this.changeStateAction(MAIN_STATE),
                isVisible: () => this.state === CREATE_STATE,
                id: 'service-account-back'
            },
            {
                title: this.$filter('translate')('main.nav.top.admin.servicePrincipal.button.save'),
                action: () => this.assignServicePrincipal(),
                isVisible: () => this.state === CREATE_STATE,
                isDisabled: () => (this.dialogForm && !this.dialogForm.$valid) || this.busy || this.state === this.MAIN_STATE,

                id: 'service-account-assign'
            }
        ];
    }

    resetVariables() {
        this.enableChangeSecret = false;
        this.searchQuery = '';
        if (this.tableState) {
            this.tableState.searchBy = '';
        }
        this.servicePrincipals = [];
        this.selectedServicePrincipal = [];
        this.filteredServicePrincipals = [];
        this.busy = false;
    }

    onOpen() {
        this.helpId = HELP_MAIN;
        this.busy = true;
        this.state = MAIN_STATE;
        // this.changeStateAction(MAIN_STATE);
        this.load();
    }

    load(firstPage) {
        this.busy = true;
        return this.getServicePrincipals(firstPage).then(resp => {
            this.filteredServicePrincipals = resp;
            if (this.animateSwitcher && !this.switcherOnChange) {
                this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                    this.minInnerHeight = !this.minInnerHeight ? this.getMinHeight() : this.minInnerHeight;
                    this.contentSwitcherService.customAnimation(this.$element, this.minInnerHeight);
                });
            }
            this.selectedServicePrincipal = [];
            this.busy = false;
            return true;

        });
    }

    getServicePrincipals(firstPage) {
        if (!this.iamPersistenceService.hasPermissions(permissions.SP_LISTING)) {
            return this.$q((resolve) => { resolve([]) })
        }

        if (firstPage && this.tableState) {
            this.tableState.page = 1;
        }
        return this.crudService.getPaged(this.proxyUrl + SERVER_API + 'servicePrincipals', this.tableState, SEARCH_KEY, null, null, 5, true, true, true).then(resp => {
            this.tableState = resp.data.tableState;
            return resp.data.entities.map(i => ({
                uuid: i.uuid,
                tenantId: i.tenantId,
                applicationId: i.applicationId,
                name: i.name,
                applicationSecret: i.applicationSecret,
                resource: i.resource,
                default: i.default,
                active: i.active
            })) || [];
        }, err => []);
    }

    onModalClose() {
        this.resetVariables();
    }

    configTable() {
        this.servPrincTableConfig = [
            this.$filter('translate')('main.nav.top.admin.servicePrincipal.form.name.label'),
            this.$filter('translate')('main.nav.top.admin.servicePrincipal.form.id.label'),
            ''
        ];
    }

    getMinHeight() {
        const modalBody = this.$element.find('.modal-body'),
            minHeight = modalBody[0] ? modalBody.css('min-height') : null;
        return minHeight ? (parseFloat(minHeight) - parseFloat(modalBody.css('padding-top')) - parseFloat(modalBody.css('padding-bottom'))) : null;
    }

    assignServicePrincipal() {
        let data = {
            tenantId: this.tenantId,
            applicationId: this.appId,
            name: this.name,
            applicationSecret: this.appSecret,
            resource: this.resource.value
        }

        this.busy = true;
        if (!this.isEditMode) {
            this.crudService.post(this.proxyUrl + SERVER_API + 'servicePrincipals', data, null, true, null, true, true).then(response => {
                this.notificationService.pop(response.data.message);
                this.getServicePrincipals().then((resp) => {
                    this.filteredServicePrincipals = resp;
                    this.changeStateAction(MAIN_STATE);
                    this.selectedServicePrincipal[0] = this.filteredServicePrincipals.filter(servicePrincipal => servicePrincipal.applicationId === data.applicationId)[0];
                    this.busy = false;
                });
            }, err => {
                this.busy = false;
            });
        } else {
            this.crudService.put(this.proxyUrl + SERVER_API + 'servicePrincipals/' + this.selectedServicePrincipal[0].uuid, data, null, true, true, true).then(response => {
                this.notificationService.pop(response.data.message);
                this.getServicePrincipals().then((resp) => {
                    this.filteredServicePrincipals = resp;
                    this.changeStateAction(MAIN_STATE);
                    this.selectedServicePrincipal[0] = this.filteredServicePrincipals.filter(servicePrincipal => servicePrincipal.applicationId === data.applicationId)[0];
                    this.busy = false;
                });
            }, err => {
                this.busy = false;
            });
        }
    }

    filterAccounts() {
        if (this.searchQuery) {
            this.filteredServicePrincipals = this.servicePrincipals.filter(oa => oa.name.match(this.searchQuery));
        } else {
            this.filteredServicePrincipals = this.servicePrincipals;
        }
    }

    manageServicePrincipal(isEdit) {
        this.isEditMode = isEdit;
        this.changeStateAction(CREATE_STATE);
    }

    onChangeSecret() {
        if (this.enableChangeSecret) {
            this.appSecret = undefined;
            this.$timeout(() => {
                this.resetSecret = true;
            }, 0)
        } else {
            this.appSecret = '********************************************';
            this.resetSecret = false;
        }
    };

    changeStateAction(state) {
        if (state === MAIN_STATE) {
            // this.modalTitle = this.mainTitle;
            // this.busy = false;
            this.isEditMode = false;
            this.enableChangeSecret = false;
            this.resetSecret = false;
            this.helpId = HELP_MAIN;
            if (this.fileWatcher) {
                this.fileWatcher();
                delete this.fileWatcher;
            }
        }
        else {
            this.busy = true;
            this.crudService.get(this.proxyUrl + SERVER_API + 'servicePrincipals/resources/dropDown', null, null, null, null, true, true, true).then(response => {
                this.availableResources = response.data.entities.map((item) => {
                    return {
                        label: item,
                        value: item
                    }
                });

                if (this.isEditMode) {
                    this.helpId = HELP_EDIT;
                    this.enableChangeSecret = false;
                    this.resource = this.availableResources[0];
                    this.name = this.selectedServicePrincipal[0].name;
                    this.tenantId = this.selectedServicePrincipal[0].tenantId;
                    this.appId = this.selectedServicePrincipal[0].applicationId;
                    this.appSecret = this.selectedServicePrincipal[0].applicationSecret
                } else {
                    this.helpId = HELP_CREATE;
                    this.resource = this.availableResources[0];;
                    this.name = '';
                    this.tenantId = '';
                    this.appId = '';
                    this.appSecret = '';
                }
                this.busy = false;
            })
        }
        this.state = state;
    }

    removeEntry(entry, e) {
        e.stopPropagation();
        this.dialogService.showYesNo(this.$filter('translate')('main.nav.top.admin.servicePrincipal.remove.text'), this.$filter('translate')('main.nav.top.admin.servicePrincipal.remove.title'), null, 'service-principal-remove', false)
            .then(res => {
                if (res) {
                    this.busy = true;
                    this.selectedServicePrincipal = [];
                    if (this.filteredServicePrincipals.length === 1 && this.tableState.page > 1) this.tableState.page--;
                    this.crudService.del(this.proxyUrl + SERVER_API + `servicePrincipals/${entry.uuid}`, null, null, null, true, true, true).then(response => {
                        if (response.data.message) this.notificationService.pop(response.data.message);
                        this.getServicePrincipals().then((resp) => {
                            this.filteredServicePrincipals = resp;
                            if (this.animateSwitcher && !this.switcherOnChange) {
                                this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                                    this.minInnerHeight = !this.minInnerHeight ? this.getMinHeight() : this.minInnerHeight;
                                    this.contentSwitcherService.customAnimation(this.$element, this.minInnerHeight);
                                });
                            }
                            this.busy = false;
                        });
                    }, err => {
                        this.busy = false;
                    });
                }
            });

    }

    setActiveServicePrincipal() {
        this.busy = this.crudService.post(this.proxyUrl + SERVER_API + 'servicePrincipals/' + this.selectedServicePrincipal[0].uuid + '/setAsActive', null, null, true, null, true, true).then((res) => {
            this.load(true);
            this.notificationService.pop(res.data.message);
        }).finally(() => this.busy = false)
    }

    // clearDefaultServicePrincipal() {
    //     this.busy = this.crudService.del(this.proxyUrl + SERVER_API + 'servicePrincipals/unSetDefault', null, null, null, true, true, true).then(() => {
    //         this.load(true);
    //     }).finally(() => this.busy = false);
    // }

    setGrid(grid) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: []
        };
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('40%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('50%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('10%');

        this.$timeout(() => {
            this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
            this.gridFlag = true;
        }, 0);
    }

    hasSpListingPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.SP_LISTING);
    }

    hasCreateSpPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.SP_CREATE);
    }

    hasUpdateSpPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.SP_UPDATE);
    }

    hasSetActivePermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.SP_DEFAULT_SET);
    }

    hasDeleteSpPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.SP_DELETE);
    }

    isSetActiveDisabled() {
        return !this.selectedServicePrincipal || !this.selectedServicePrincipal.length || this.selectedServicePrincipal[0].active || !this.hasSetActivePermissions()
    }

    isUpdateSpDisabled() {
        return !this.selectedServicePrincipal[0] || !this.hasUpdateSpPermissions();
    }

    isCreateSpDisabled() {
        return !this.hasCreateSpPermissions()
    }

}

ServicePrincipalController.$inject = ['$element', '$scope', '$filter', '$window', '$timeout', '$q', 'crudService', 'storageService', 'dialogService', 'loginService', 'notificationService', 'contentSwitcherService', 'config', 'validationsService', 'iamPersistenceService'];

const servicePrincipalComponent = {
    controller: ServicePrincipalController,
    template: require('./servicePrincipal.template.html'),
    bindings: {
        showModal: '='
    }
};

module.exports = servicePrincipalComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/dialogs/servicePrincipal/servicePrincipal.component.js